import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded"
import { Box, Button, Typography } from "@mui/material"
import STRING_CONSTANTS from "../../shared/constants/StringConstants"
import schemeTokens from "./tokens"

const SchemePromoBanner = ({ onJoin, disabled }) => (
  <Box
    sx={{
      position: "relative",
      overflow: "hidden",
      borderRadius: schemeTokens.radius.card,
      bgcolor: "primary.main",
      color: "primary.contrastText",
      px: 2.5,
      py: 2.5,
    }}
  >
    <Box
      aria-hidden
      sx={{
        position: "absolute",
        top: -60,
        right: -70,
        width: 220,
        height: 220,
        borderRadius: "50%",
        border: "1px solid",
        borderColor: "rgba(255,255,255,.22)",
      }}
    />
    <Box
      aria-hidden
      sx={{
        position: "absolute",
        top: -20,
        right: -120,
        width: 220,
        height: 220,
        borderRadius: "50%",
        border: "1px solid",
        borderColor: "rgba(255,255,255,.16)",
      }}
    />

    <Box sx={{ position: "relative" }}>
      <Box
        component="span"
        sx={{
          ...schemeTokens.text.eyebrow,
          display: "inline-block",
          px: 1,
          py: 0.4,
          borderRadius: schemeTokens.radius.pill,
          bgcolor: "rgba(255,255,255,.22)",
        }}
      >
        {STRING_CONSTANTS.SCHEMES}
      </Box>

      <Typography
        sx={{ fontSize: 21, fontWeight: 700, lineHeight: 1.25, mt: 1.25 }}
      >
        {STRING_CONSTANTS.SCHEME_PROMO_TITLE}
      </Typography>
      <Typography sx={{ ...schemeTokens.text.body, mt: 0.75, opacity: 0.92 }}>
        {STRING_CONSTANTS.SCHEME_PROMO_SUBTITLE}
      </Typography>

      <Button
        onClick={onJoin}
        disabled={disabled}
        endIcon={<ChevronRightRoundedIcon />}
        sx={{
          mt: 2,
          px: 2,
          bgcolor: "common.white",
          color: "text.primary",
          fontWeight: 700,
          borderRadius: schemeTokens.radius.control,
          "&:hover": { bgcolor: "common.white" },
        }}
      >
        {STRING_CONSTANTS.JOIN_SCHEME}
      </Button>
    </Box>
  </Box>
)

export default SchemePromoBanner
